import { Navigate, useLocation } from "react-router-dom";
import { useProject } from "./ProjectContext";

export const ProtectedRoute = ({ children, project }) => {
    const { allowedPages, allowedProjects } = useProject();
    const location = useLocation();
    if (!allowedPages || !allowedProjects) {
        // You might want to show a loading state here
        return <div></div>;
    }

    if (project && !allowedProjects.includes(project)) {
        return <Navigate to="/not-authorized" />;
    }

    if (!allowedPages.includes(location.pathname)) {
        return <Navigate to="/not-authorized" />;
    }

    return children;
};